export const isNotEmpty = (value) => value.toString().trim() !== "";
